import { useSessionStore } from "../../../stores"

export interface BirddogProfile {
  birddog_role: "forester" | "timber_buyer"
  user_id: number
}

export const useBirddogProfile = (): BirddogProfile | null => {
  const authData = useSessionStore((state) => state.authData)

  if (!authData || !authData.birddog_role) {
    return null
  }

  return {
    birddog_role: authData.birddog_role,
    user_id: authData.user_id,
  }
}

export const useBirddogRole = (): "forester" | "timber_buyer" | null => {
  const profile = useBirddogProfile()
  return profile?.birddog_role || null
}

export const useIsBirddogForester = (): boolean => {
  const role = useBirddogRole()
  return role === "forester"
}

export const useIsBirddogTimberBuyer = (): boolean => {
  const role = useBirddogRole()
  return role === "timber_buyer"
}
